"use client";

import { useMemo, useTransition } from "react";

import { Icons } from "@/components/shared/icons";
import { Button } from "@/components/ui/button";
import * as m from "@/paraglide/messages";
import { generateUserStripe } from "@/services/actions/generate-user-stripe";
import { useAuth } from "@/services/context/auth/AuthContext";
import { SubscriptionPlan, UserSubscriptionPlan } from "@/types";

interface BillingFormButtonProps {
  offer: SubscriptionPlan;
  subscriptionPlan: UserSubscriptionPlan;
  year: boolean;
  isInneos?: boolean;
  isLifetime?: boolean;
  isKevin?: boolean;
  withTrial?: boolean;
}

const base_url = () => {
  return window.location.origin + "/" + window.location.pathname;
};

export function BillingFormButton({
  year,
  offer,
  isInneos,
  isKevin,
  isLifetime,
  withTrial = false,
}: BillingFormButtonProps) {
  const { user } = useAuth();
  let [isPending, startTransition] = useTransition();

  const stripeId = useMemo(
    () =>
      offer.stripeIds[
        isLifetime
          ? "lifetime"
          : isKevin
          ? "kevin_lifetime"
          : isInneos
          ? year
            ? "inneos_yearly"
            : "inneos_lifetime"
          : year
          ? "yearly"
          : "monthly"
      ],
    [offer.stripeIds, isLifetime, isKevin, isInneos, year],
  );

  const generateUserStripeSession = generateUserStripe.bind(
    null,
    stripeId as string,
    user?.uid.toString(),
    false,
    true,
    base_url(),
    withTrial,
  );

  const stripeSessionAction = () =>
    startTransition(async () => (await generateUserStripeSession()) as any);

  return (
    <Button
      variant="outline"
      disabled={isPending}
      onClick={stripeSessionAction}
      size="sm"
    >
      {isPending ? (
        <>
          <Icons.spinner className="mr-2 size-4 animate-spin" /> {m.loading_()}
        </>
      ) : (
        <>{m.pay_now()}</>
      )}
    </Button>
  );
}
